export const getPublicUrl = () => {
    if (window.location.hostname.includes("-")) {
        return "https://ipu-edu.uz";
    }
    return "https://ipuedu.uz";
};
